import { render, staticRenderFns } from "./ForgotPasswordEmailSent.vue?vue&type=template&id=45553836&scoped=true&"
import script from "./ForgotPasswordEmailSent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordEmailSent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordEmailSent.vue?vue&type=style&index=0&id=45553836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45553836",
  null
  
)

export default component.exports